import { Injectable, inject } from '@angular/core';
import UserRestServices from '../services/user-rest.service';
import DialogServices from '../services/dialog.service';
import Config from '../utils/config.service';
import ServiceRestServices from '../services/service-rest.service';
import FetchingService from '../services/fetching.service';
import InstantBookingService from '../services/instant-booking.service';
import BusinessService from '../services/business.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';
import AngularStateHelperService from '../services/angular-state-helper.service';
import AngularBroadcastHelperService from '../services/angular-broadcast-helper.service';
import DictionaryService from '../services/dictionary.service';
import { ModalSwitchToAdminAssistantComponent } from '../components/modal-switch-to-admin-assistant/modal-switch-to-admin-assistant.component';
import { ModalSwitchToPatientComponent } from '../components/modal-switch-to-patient/modal-switch-to-patient.component';
import { ModalConsentsComponent } from '../components/modal-consents/modal-consents.component';

@Injectable({ providedIn: 'root' })
export default class Session {
	private userRestServices: UserRestServices = inject(UserRestServices);
	private dialogServices: DialogServices = inject(DialogServices);
	private config: Config = inject(Config);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private fetchingService: FetchingService = inject(FetchingService);
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	private businessService: BusinessService = inject(BusinessService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dictionaryService: DictionaryService = inject(DictionaryService);
	
	SENTAB_SESSION_COOKIE: any = 'SENTAB_SESSION_ID';
	
	initialEmployerInviteShown: any = false;
	
	constructor() {
		this.angularStateHelperService.setGlobalProperty('SCOnlineStatuses', {});
		this.angularStateHelperService.setGlobalProperty('isLoggedIn', false);
		
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.DESTROY, () => {
			this.logout();
		});
		
		//this.resolve(); // TODO ANGULAR_2 this here is causing double loading. Why is it here?
	}
	
	updateSession(newSessionData?) {
		console.log("updateSession");
		if (newSessionData) {
			this.angularStateHelperService.setGlobalProperty('session', newSessionData);
			this.dictionaryService.setLanguage(newSessionData && newSessionData.user && newSessionData.user.deviceLanguage).catch(() => {});
			this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Session.UPDATE, this.angularStateHelperService.getGlobalProperty('session'));
		} else {
			this.fetchingService.get('SESSION', { refetch: true })
				.then((response) => {
					this.angularStateHelperService.setGlobalProperty('session', this.angularHelperService.copy(response));
					this.dictionaryService.setLanguage(response && response.user && response.user.deviceLanguage).catch(() => {});
					this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Session.UPDATE, this.angularStateHelperService.getGlobalProperty('session'));
				})
				.catch((err) => {
					if (!this.angularHelperService.isPublicPath()) {
						this.goToLogin();
					}
				});
		}
	}
	
	goToLogin(path?) {
		path = path || '/logi-sisse';
		var host: any = window.location.href;
		if (host.includes('eelvisiit')) {
			path = this.config.getPublicWebUrlUsingDomain('minudoc.ee') + '/previsit'
		}
		window.location.href = path;
	}
	
	updateProfilePicture(newProfilePicture) {
		var newSession: any = this.angularStateHelperService.getGlobalProperty('session');
		newSession.user.fileUrl = null;
		newSession.user.profilePicture = newProfilePicture;
		this.updateSession(newSession);
	}
	
	updateCoverPicture(newCoverPicture) {
		var newSession: any = this.angularStateHelperService.getGlobalProperty('session');
		newSession.user.coverPicture = newCoverPicture;
		this.updateSession(newSession);
	}
	
	login(credentials, successCallback, errorCallback) {
		this.userRestServices.login(credentials,
			(response) => {
				this.handleLogin(JSON.parse(response), successCallback);
			},
			(error) => {
				errorCallback(error);
			}
		);
	}
	
	handleLogin(sessionData, successCallback) {
		var user: any = sessionData.user;
		this.dictionaryService.setLanguage(user && user.deviceLanguage).catch(() => {});
		// Pre-fetch some data for MinuDoc home page
		if (user && user.origin == "minudoc.ee" 
			&& (this.angularRoutingHelperService.getCurrentPath() === '/' || this.angularRoutingHelperService.getCurrentPath() === '')) {
			this.fetchingService.get('CATEGORIES', {
				params: {
					language: user.deviceLanguage || 'et_EE',
					origin: user.origin,
					includeFurtherSubcategory: true,
					includeDescription: true
				}
			}).then((res) => { });
		}

		this.angularStateHelperService.setGlobalProperty('session', sessionData);
		this.angularHelperService.createTimer(() => {
			this.angularStateHelperService.setGlobalProperty('isLoggedIn', true);

			if (!sessionData.user.businessUser || sessionData.user.businessUserType === 'SERVICE_PROVIDER') {
				if (sessionData.user.workerInvitation && sessionData.user.signupCompleted && !this.initialEmployerInviteShown) {
					this.initialEmployerInviteShown = true;
					this.businessService.showEmployerInvitationModal(sessionData.user);
				}
			}

			if (!sessionData.user.businessUser) {
				this.userRestServices.getConsentsStatus(
					(consents) => {
						if (consents.activePrivacyPolicy !== undefined && consents.activeTermsOfService !== undefined) {
							if (consents.activePrivacyPolicy != consents.latestPrivacyPolicy
								|| consents.activeTermsOfService != consents.latestTermsOfService) {
								if (sessionData.user.signupCompleted) this.showGeneralAcceptModal(consents);
							}
						} else {
							console.log('User has not accepted general consents');
						}
					},
					(error) => {
						console.log('Failed loading user consents status', error);
					}
				);
			}

			if (successCallback) successCallback(sessionData);
		}, 50);

		this.angularHelperService.createTimer(() => {
			this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Session.LOGIN,
				this.angularStateHelperService.getGlobalProperty('session'));
		}, 150);

		this.angularHelperService.createTimer(() => {
			this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Session.INIT_CHAT,
				this.angularStateHelperService.getGlobalProperty('session'));
		}, (this.angularRoutingHelperService.getCurrentPath() === '/' || this.angularRoutingHelperService.getCurrentPath() === '') ? 400 : 250);

		this.angularHelperService.createTimer(() => {
			var session: any = this.angularStateHelperService.getGlobalProperty('session');
			if (!session.callClientInitCalled) {
				session.callClientInitCalled = true;
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Session.INIT_CALL_CLIENT, session);
			}
		}, 5000);

		this.angularHelperService.createTimer(() => {
			var session: any = this.angularStateHelperService.getGlobalProperty('session');
			if (!session.pushNotificationsInitCalled) {
				session.pushNotificationsInitCalled = true;
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Session.INIT_PUSH_NOTIFICATIONS, session);
			}
		}, 10000);
	}
	
	showGeneralAcceptModal(consents) {
		var isModalOpen: any = this.angularHelperService.element(document.body).hasClass('md-dialog-is-showing');
		if (!isModalOpen) {
			this.dialogServices.show({
				controller: ModalConsentsComponent,
				data: consents,
				clickOutsideToClose: false,
				escapeToClose: false,
			});
		} else {
			var listener: any = this.angularHelperService.createInterval(() => {
				var nv: any = this.angularHelperService.element(document.body).hasClass('md-dialog-is-showing');
				if (!nv) {
					setTimeout(() => {
						this.dialogServices.show({
							controller: ModalConsentsComponent,
							data: consents,
							clickOutsideToClose: false,
							escapeToClose: false,
						});
	
					});
					this.angularHelperService.cancelInterval(listener);
				}
			}, 800);
		}
	}
	
	logout(closeWindow?: boolean) {
		if (this.instantBookingService.isAvailable()) this.serviceRestServices.setInstantBookingAvailabilityStatus({ status: 'OFFLINE' }, {});
		this.userRestServices.logout(
			() => {
				this.logoutAndClearData(closeWindow);
			},
			() => {
				this.logoutAndClearData(closeWindow);
			}
		);
	}
	
	logoutAndClearData(closeWindow?: boolean) {
		var path: any = '/';
		this.angularStateHelperService.setGlobalProperty('isLoggedIn', false);
		this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Session.LOGOUT);
		window.localStorage.clear();
		window.sessionStorage.clear();
		this.removeSessionCookie();
		if (closeWindow) {
			window.open('', '_self');
			window.close();
			
			setTimeout(() => {
				if (!window.closed) {
					this.goToLogin(path);
				}
			}, 500);
		} else {
			this.goToLogin(path);
		}
	}
	
	removeSessionCookie() {
		this.angularHelperService.deleteCookie(this.SENTAB_SESSION_COOKIE, { path: '/' });
	}
	
	logoutWithConfirmation(event, closeWindow?: boolean) {
		var dialog = this.dialogServices.confirmation({
			targetEvent: event,
			title: this.angularFilterHelperService.translate('Modal.Title.Log_Out'),
			content: this.angularFilterHelperService.translate('Modal.Content.Log_Out'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.logout(closeWindow);
			}
		});
	}
	
	switchServiceProviderRole(event) {
		var user: any = (this.getSession() || {}).user || {};

		if (user.businessRoleDisabled) {
			var dialog = this.dialogServices.confirmation({
				targetEvent: event,
				title: this.angularFilterHelperService.translate('Modal.Title.Switch_Role_Title'),
				content: this.angularFilterHelperService.translate('Modal.Content.Switch_Role_To_Service_Provider'),
			});
			dialog.afterClosed().subscribe((data) => {
				if (data) {
					this.toggleRole();
				}
			});
		} else {
			this.dialogServices.show({
				controller: ModalSwitchToPatientComponent,
				clickOutsideToClose: false,
				escapeToClose: false
			});
		}
	}
	
	toggleAdminAssistantStatus(event) {
		this.dialogServices.show({
			controller: ModalSwitchToAdminAssistantComponent,
			clickOutsideToClose: false,
			escapeToClose: false
		});
	}
	
	toggleRole() {
		this.userRestServices.toggleRole().then(
			() => {
				window.location.href = window.location.href.split('#')[0];
			},
			(err) => {
				console.log(err);
			}
		);
	}
	
	isLoggedIn() {
		return this.angularStateHelperService.getGlobalProperty('isLoggedIn');
	}
	
	getSession() {
		return this.angularStateHelperService.getGlobalProperty('session');
	}
	
	canUserManuallyAddInsurance() {
		var session: any = this.getSession();
		if (session
			&& session.user
			&& session.user.businessUserType == 'BUSINESS_CLIENT'
			&& session.user.service
			&& session.user.service.manuallyAddInsurancePolicy
			&& session.user.activeInsurancePolicies
			&& session.user.activeInsurancePolicies.length > 0) {
			return true;
		} else {
			return false;
		}
	}
	
	isInsuranceDatePickerHidden() {
		var session: any = this.getSession();
		if (session
			&& session.user
			&& session.user.businessUserType == 'BUSINESS_CLIENT'
			&& session.user.service
			&& session.user.service.hideInsuranceDatePicker) {
			return true;
		} else {
			return false;
		}
	}
	
	resolve() {
		var deferred: any = this.angularHelperService.getDeferredPromise();

		if (!this.angularStateHelperService.getGlobalProperty('isLoggedIn')) {
			this.fetchingService.get('SESSION')
				.then((response) => {
					this.handleLogin(response, () => {
						deferred.resolve();
					});
				}).catch((err) => {
					if (!this.angularHelperService.isPublicPath()) {
						deferred.reject();
						this.goToLogin();
					} else {
						deferred.resolve();
					}
				});
		} else {
			deferred.resolve();
		}

		return deferred.promise;
	}
	
}
